import React from 'react'

export default function Contact() {
  return <>
  
   <div className="container mt-5" style={{ maxWidth: '700px' }}>
      <h2 className="text-center mb-4">Contact Us</h2>
      <hr />

      <form>
        {/* الاسم */}
        <div className="mb-3">
          <label htmlFor="name" className="form-label">Name</label>
          <input 
            type="text" 
            className="form-control" 
            id="name" 
            placeholder="Enter your name" 
          />
        </div>

        {/* الإيميل */}
        <div className="mb-3">
          <label htmlFor="email" className="form-label">Email</label>
          <input 
            type="email" 
            className="form-control" 
            id="email" 
            placeholder="name@example.com" 
          />
        </div>

        {/* الرسالة */}
        <div className="mb-3">
          <label htmlFor="message" className="form-label">Message</label>
          <textarea 
            className="form-control" 
            id="message" 
            rows="5" 
            placeholder="Enter your message"
          ></textarea>
        </div>

        {/* زر الإرسال */}
        <div className="text-center">
          <button type="submit" className="btn btn-dark px-4">
            Send
          </button>
        </div>
      </form>
    </div>
  </>
}
